import { Controller } from '@hotwired/stimulus'
import { playSoundByKey } from '../utils/notification_sounds'

export default class extends Controller {
  static targets = ['select']

  play(event) {
    event.preventDefault()
    const key = this.selectTarget.value
    playSoundByKey(key, key)
  }
}
